<!--
  Landing-страница для суперпользователя.
  По ТЗ «Рабочие задачи» блок 7: `is_superuser` не должен попадать
  в оперативный UI (ЧПГО/КПС/WMS). Ведём его сюда — со ссылкой на
  Django Admin, где заводятся справочники, пользователи и т.п.
-->
<template>
  <section class="admin-landing">
    <div class="admin-landing__card">
      <h1>{{ $t('admin.adminPanel') }}</h1>
      <p class="admin-landing__intro" v-html="$t('admin.adminPanelHint', { name: `<b>${escaped(userDisplay)}</b>` })" />
      <div class="admin-landing__actions">
        <a class="admin-landing__btn admin-landing__btn--primary" :href="adminUrl">
          {{ $t('admin.openDjangoAdmin') }}
        </a>
        <button class="admin-landing__btn" @click="logout">
          {{ $t('nav.logout') }}
        </button>
      </div>
      <div class="admin-landing__hint" v-html="$t('admin.adminHelp', { role: '<b>«' + $t('routes.chpoStart') + '»</b>' })" />
    </div>
  </section>
</template>

<script>
import { getCachedCurrentUser, ensureCurrentUser } from '@/api/user'

export default {
  name: 'AdminLandingView',
  data() {
    return {
      user: getCachedCurrentUser() || null,
    }
  },
  computed: {
    userDisplay() {
      const u = this.user
      if (!u) return 'администратор'
      return u.full_name || u.iin || 'администратор'
    },
    adminUrl() {
      // Backend слушает `/admin/` независимо от dev/prod.
      const host = window.location.hostname
      if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:8000/admin/'
      const proto = window.location.protocol
      return `${proto}//${host}/admin/`
    },
  },
  async mounted() {
    if (!this.user) {
      try { this.user = await ensureCurrentUser() } catch {}
    }
  },
  methods: {
    logout() {
      import('@/middlewares/auth').then(({ logout }) => logout())
    },
    escaped(s) {
      return String(s || '').replace(/[&<>"']/g, ch => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[ch]))
    },
  },
}
</script>

<style scoped>
.admin-landing {
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}
.admin-landing__card {
  max-width: 640px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);
}
.admin-landing__card h1 {
  margin: 0 0 16px;
  font-size: 28px;
  color: #111827;
}
.admin-landing__intro {
  color: #374151;
  line-height: 1.55;
  font-size: 15px;
  margin-bottom: 24px;
}
.admin-landing__actions {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}
.admin-landing__btn {
  padding: 12px 20px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #F3F4F6;
  color: #111827;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
}
.admin-landing__btn--primary {
  background: #2A8A1B;
  border-color: #2A8A1B;
  color: #FFFFFF;
}
.admin-landing__btn--primary:hover { background: #1F6D14; }
.admin-landing__hint {
  color: #6B7280;
  font-size: 13px;
  line-height: 1.4;
  padding-top: 16px;
  border-top: 1px solid #F3F4F6;
}
</style>
